import {useMutation} from '@tanstack/react-query';

import {apiClient} from '../../../../utils/api-client';

function runQueryRequest(queryId: number) {
    return apiClient.post<QueryInfo>({
        path: `queries-service/api/queries/${queryId}/run`
    });
}

export function useRunQueryMutation() {
    return useMutation<QueryInfo, Error, number>({
        mutationFn: runQueryRequest
    });
}
